import { useCallback, useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import PropTypes from "prop-types";
import { difference } from "lodash";

const ACFCheckboxes = ({
	allowOther,
	choices,
	className,
	instructions,
	label,
	name,
	onChange,
	value
}) => {
	const [showOther, setShowOther] = useState(false);
	const [otherValue, setOtherValue] = useState("");
	const handleOtherCheck = useCallback(({ target }) => {
		if (target.checked) {
			setShowOther(true);
		} else {
			onChange({
				target: {
					checked: false,
					name,
					value: otherValue
				}
			});
			setShowOther(false);
		}
	}, []);

	const handleOtherChange = useCallback(({ target: { value: otherVal } }) => {
		onChange({
			target: {
				checked: false,
				name,
				value: otherValue
			}
		});

		onChange({
			target: {
				checked: true,
				name,
				value: otherVal
			}
		});

		setOtherValue(otherVal);
	}, [name, otherValue]);

	useEffect(() => {
		const hasOther = difference(value, Object.keys(choices));
		if (hasOther.length && hasOther[0]) {
			setShowOther(true);
			setOtherValue(hasOther[0]);
		}
	}, []);

	return (
		<Form.Group className={className}>
			<Form.Label className="fw-bold d-block mb-2" htmlFor={name}>{label}</Form.Label>
			{instructions ? <Form.Text className="d-block mb-2">{instructions}</Form.Text> : null}
			{Object.entries(choices).map(([val, choiceLabel]) => (
				<Form.Check
					checked={(value || []).indexOf(val) !== -1}
					id={`${name}-${val}`}
					key={val}
					label={choiceLabel}
					name={name}
					onChange={onChange}
					type="checkbox"
					value={val}
				/>
			))}
			{allowOther ? (
				<>
					<Form.Check
						checked={showOther}
						id={`${name}-other`}
						label="Other"
						name={name}
						onChange={handleOtherCheck}
						type="checkbox"
						value={otherValue}
					/>
					{showOther ? (
						<Form.Control
							onChange={handleOtherChange}
							placeholder="Enter other..."
							value={otherValue}
						/>) : null}
				</>
			) : null}
		</Form.Group>
	);
};

ACFCheckboxes.propTypes = {
	allowOther: PropTypes.bool,
	choices: PropTypes.oneOfType([
		PropTypes.arrayOf(PropTypes.string),
		PropTypes.shape({})
	]).isRequired,
	className: PropTypes.string,
	instructions: PropTypes.string,
	label: PropTypes.string.isRequired,
	name: PropTypes.string.isRequired,
	onChange: PropTypes.func.isRequired,
	value: PropTypes.arrayOf(PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.number
	]))
};

ACFCheckboxes.defaultProps = {
	allowOther: false,
	className: "",
	instructions: null,
	value: []
};

export default ACFCheckboxes;
